export default {"src":"/_next/static/media/transparent.ef5c7053.svg","height":48,"width":49};